export default "__VITE_ASSET__2TtBCKrZ__";